import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Send, Users, GraduationCap } from 'lucide-react';

const Careers = () => {
  return (
    <section className="relative bg-[#0c3754] py-24 md:py-32 px-8 md:px-16 overflow-hidden">
      
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[400px] h-[400px] rounded-full bg-white/20 blur-[120px]" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[300px] h-[300px] rounded-full bg-[#78BE20]/20 blur-[100px]" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="bg-white/[0.03] border border-white/10 rounded-xl p-8 md:p-20 backdrop-blur-xl shadow-2xl">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <div className="flex items-center gap-4 mb-8">
                <div className="w-10 h-10 rounded-full bg-[#78BE20]/10 flex items-center justify-center">
                  <Briefcase size={18} className="text-[#78BE20]" />
                </div>
                <span className="text-[10px] uppercase tracking-[0.4em] text-[#78BE20] font-bold">
                  Careers at LCaaS
                </span>
              </div>

              <h2 className="text-4xl md:text-6xl font-serif text-white leading-tight mb-8">
                Join our <span className="text-white/40">Elite</span> <br /> Legal Network
              </h2>

              <p className="text-lg text-white/60 font-light leading-relaxed mb-10 max-w-md">
                If you are a qualified lawyer or a professional <span className="text-white/90 font-medium">(CA/CS/CFA)</span>, we invite you to shape the future of compliance with us.
              </p>

              <div className="flex flex-wrap gap-8">
                 <div className="flex items-center gap-3">
                    <Users size={16} className="text-white/30" />
                    <span className="text-[10px] uppercase tracking-widest text-white/50 font-bold">Open Positions</span>
                 </div>
                 <div className="flex items-center gap-3">
                    <GraduationCap size={16} className="text-white/30" />
                    <span className="text-[10px] uppercase tracking-widest text-white/50 font-bold">Internships</span>
                 </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="relative group"
            >
              <div className="absolute -inset-4 bg-gradient-to-tr from-[#78BE20]/20 to-transparent blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              
              <div className="relative bg-white/5 border border-white/10 rounded-xl p-10 md:p-12 text-center flex flex-col items-center">
                <h3 className="text-xl font-serif text-white mb-6">Ready to connect?</h3>
                <p className="text-sm text-white/40 mb-10 leading-relaxed">
                  Provide us with your details and interests. We look forward to exploring synergies.
                </p>

                <a 
                  href="mailto:anshoo@lcaas.in"
                  className="w-full bg-[#78BE20] hover:bg-white text-[#0c3754] font-bold py-5 px-8 rounded-lg flex items-center justify-center gap-3 transition-all duration-500 group/btn"
                >
                  <span className="uppercase tracking-[0.2em] text-xs">Email Your Profile</span>
                  <Send size={16} className="group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1 transition-transform" />
                </a>

                <p className="mt-8 text-[10px] uppercase tracking-[0.3em] text-white/20 font-bold">
                  anshoo@lcaas.in
                </p>
              </div>
            </motion.div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Careers;